/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Injectable()
export class OwlService {
  owlOption1: OwlOptions = {

  };
  owlOption2: any;
  owlOption3:any
  owlCityOption:any;

  popularbrandOption:any;
  prodMultImgOption:any

  multiBrandsOption:any

  updatedProdOptions!: { dots: boolean; navigation: boolean; items: number; autoplay: boolean; autoplayTimeout: number; loop: boolean; responsive: { 0: { items: number; }; 600: { items: number; }; 1000: { items: number; }; }; };

  owlHomecard!: {
    dots: boolean; loop: boolean; nav: boolean; autoWidth: boolean; skip_validateItems: boolean; margin: number; items: number; lazyLoad: boolean; touchDrag: boolean; autoplay: boolean; autoplayTimeout: number;
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    navSpeed: number;
    // smartSpeed:2000,
    responsive: { 0: { items: number; }; 400: { items: number; }; 740: { items: number; }; 940: { items: number; }; 1080: { items: number; }; 1240: { items: number; }; 1440: { items: number; }; }; navText: string[];
  };
  owlHomeoffercard!: {
    dots: boolean; loop: boolean; nav: boolean; autoWidth: boolean; skip_validateItems: boolean; margin: number; items: number; lazyLoad: boolean; touchDrag: boolean; autoplay: boolean; autoplayTimeout: number;
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    navSpeed: number;
    // smartSpeed:2000,
    responsive: { 0: { items: number; }; 400: { items: number; }; 740: { items: number; }; 940: { items: number; }; 1080: { items: number; }; 1240: { items: number; }; 1440: { items: number; }; }; navText: string[];
  };
  owlHomebannerClick!: {
    dots: boolean; loop: boolean; nav: boolean; autoWidth: boolean; skip_validateItems: boolean; margin: number; items: number; lazyLoad: boolean; touchDrag: boolean; autoplay: boolean; autoplayTimeout: number;
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    navSpeed: number;
    // smartSpeed:2000,
    responsive: { 0: { items: number; }; 400: { items: number; }; 740: { items: number; }; 940: { items: number; }; 1080: { items: number; }; 1240: { items: number; }; 1440: { items: number; }; }; navText: string[];
  };
  owlBannerOption!: {
    dots: boolean; loop: boolean; nav: boolean; autoWidth: boolean; skip_validateItems: boolean; margin: number; items: number; lazyLoad: boolean; touchDrag: boolean; autoplay: boolean; autoplayTimeout: number;
    // animateOut: 'fadeOut',
    // animateIn: 'fadeIn',
    navSpeed: number;
    // smartSpeed:2000,
    navText: string[];
  };

  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    
    if (this.isBrowser) {

    this.owlHomecard = {
      dots: false,
      loop:false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      margin: 0,
      items: 5,
      lazyLoad: false,
      touchDrag:false,
      autoplay:false,
      autoplayTimeout:8000,
      // animateOut: 'fadeOut',
      // animateIn: 'fadeIn',
      navSpeed:200,
      // smartSpeed:2000,
      responsive: {
        0: {
          items: 3,
        },
        400: {
          items: 4,
        },
        740: {
          items: 4,
        },
        940: {
          items: 4,
        },
        1080: {
          items: 6,
        },
        1240: {
          items: 6,
        },
        1440: {
          items: 6,
        },},
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    }
    this.owlBannerOption = {
      dots: true,
      loop:true,
      nav: false,
      autoWidth: false,
      skip_validateItems:true,
      margin: 0,
      items: 1,
      lazyLoad: false,
      touchDrag:false,
      autoplay:true,
      autoplayTimeout:5000,
      // animateOut: 'fadeOut',
      // animateIn: 'fadeIn',
      navSpeed:10000,
      // smartSpeed:2000,
      
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
      
    }
    
    this.owlOption1 = {
      dots: false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      margin: 0,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 3,
        },
        740: {
          items: 3,
        },
        940: {
          items: 3,
        },
        1080: {
          items: 3,
        },
        1240: {
          items: 4,
        },
        1440: {
          items: 4,
        },
      },
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    }

    this.owlOption2 = {
      // items:8,
      dots: false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 3,
        },
        740: {
          items: 5,
        },
        940: {
          items: 7,
        },
        1080: {
          items: 7,
        },
        1240: {
          items: 8,
        },
        1440: {
          items: 8,
        }
      },
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    };
    this.owlOption3 = {
      // items:8,
      dots: false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      responsive: {
        0: {
          items: 3,
        },
        400: {
          items: 5,
        },
        740: {
          items: 7,
        },
        940: {
          items: 10,
        },
        1080: {
          items: 10,
        },
        1240: {
          items: 12,
        },
        1440: {
          items: 12,
        }
      },
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    };
    this.owlHomeoffercard = {
      dots: false,
      loop:false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      margin: 0,
      items: 5,
      lazyLoad: false,
      touchDrag:true,
      autoplay:false,
      autoplayTimeout:8000,
      // animateOut: 'fadeOut',
      // animateIn: 'fadeIn',
      navSpeed:200,
      // smartSpeed:2000,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 2,
        },
        740: {
          items: 3,
        },
        940: {
          items: 4,
        },
        1080: {
          items: 5,
        },
        1240: {
          items: 6,
        },
        1440: {
          items: 7,
        },},
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    }
    this.owlHomebannerClick = {
      dots: false,
      loop:false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      margin: 6,
      items: 5,
      lazyLoad: false,
      touchDrag:true,
      autoplay:false,
      autoplayTimeout:8000,
      // animateOut: 'fadeOut',
      // animateIn: 'fadeIn',
      navSpeed:200,
      // smartSpeed:2000,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 3,
        },
        740: {
          items: 3,
        },
        940: {
          items: 3,
        },
        1080: {
          items: 4,
        },
        1240: {
          items: 4,
        },
        1440: {
          items: 4,
        },},
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    }
    this.owlCityOption = {
      // items:8,
      dots: false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 4,
        },
        740: {
          items: 7,
        },
        940: {
          items: 10,
        },
        1080: {
          items: 10,
        },
        1240: {
          items: 13,
        },
        1440: {
          items: 13,
        }
      },
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    };
    this.popularbrandOption = {
      items: 9,
      dots: false,
      nav: true,
      autoWidth: false,
      skip_validateItems:true,
      margin: 0,
      responsiveClass: true,
      responsive: {
        0: {
          items: 2,
        },
        400: {
          items: 5,
        },
        740: {
          items: 5,
        },
        940: {
          items: 6,
        },
        1080: {
          items: 6,
        },
        1240: {
          items: 8,
        },
        1440: {
          items: 8,
        },
      },
      navText: [
        '<i class="fa fa-angle-left arrolefts" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right arrorights" aria-hidden="true"></i>',
      ],
    };
    /*product page options */
    this.prodMultImgOption = {
      dots: false,
      navigation:true,
      items: 1,
      autoplay: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    }
    this.multiBrandsOption = {
      dots: false,
      navigation:false,
      items: 1,
      autoplay: true,
      loop:true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    }
    this.updatedProdOptions = {
      dots: true,
      navigation:true,
      items: 1,
      autoplay: true,
      autoplayTimeout: 1500,
      loop: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    }
    /*product page options End */
 
  }
}

}


